import axios from '../config/axios'
import ImportHistory from '../models/ImportHistory'

export const importCsv = (csv: File) => {
  const formData = new FormData()
  formData.append('csv', csv)
  return axios.post<string>('api/contributions/import', formData, {
    timeout: 60 * 60 * 1000,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const findHistory = (importType?: string) =>
  axios.get<ImportHistory[]>('api/imports/history', {
    params: {
      importType,
    },
  })

export default { importCsv, findHistory }
